module.exports = __webpack_public_path__ + "img/23_51.e7ce63d0.png";